module.exports = __webpack_public_path__ + "static/media/url.050b972b.svg";